import { Box, Button, FormControl, FormHelperText, InputAdornment, InputLabel, OutlinedInput, Stack, TextField, Typography, } from '@mui/material'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FunctionComponent } from 'react';
import { IFinishedProduct } from '../../../shared/services/finished-product/finished-product.model';
import { Link } from 'react-router-dom';

export const FinishedProductForm: FunctionComponent<{
  finishedProduct?: IFinishedProduct,
  isEditPage: boolean,
  onSubmit: (values: IFinishedProduct) => void
}> = ({
  finishedProduct,
  isEditPage = false,
  onSubmit
}) => {

    const finishedProductSchema = Yup.object().shape({
      name: Yup.string().required('Please give this product a name'),
      description: Yup.string().nullable(),
      productConfiguration: Yup.string().nullable(),
      kgCarbonEmission: Yup.number().nullable()
    })

    const formik = useFormik<IFinishedProduct>({
      initialValues: {
        name: finishedProduct?.name,
        description: finishedProduct?.description,
        productConfiguration: finishedProduct?.productConfiguration,
        kgCarbonEmission: finishedProduct?.kgCarbonEmission,
        skuCode: finishedProduct?.skuCode,
      },
      validationSchema: finishedProductSchema,
      onSubmit: (values) => {
        onSubmit(values)
      }
    })

    const updateHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      formik.setFieldValue(e.target.name, e.target.value)
    }

    return (
      <Box component='form'>
        <Stack display='flex' flexDirection='column'>
          <Typography variant='h6' sx={{ mb: 2 }}>{isEditPage ? 'Edit Product' : 'Create New Product'}</Typography>
          <Stack sx={{ mb: 2 }}>
            <FormControl disabled >
              <TextField
                label='Product name'
                onChange={updateHandler}
                name='name'
                sx={{ color: 'text.secondary' }}
                error={formik.touched.name && Boolean(formik.errors.name)}
                value={formik.values.name || ''} />
            </FormControl>
            {formik.touched.name && formik.errors.name &&
              <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                {formik.errors.name ? <div>{formik.errors.name as string}</div> : null}
              </FormHelperText>
            }
          </Stack>

          <FormControl disabled sx={{ mb: 2 }}>
            <TextField
              label='Description'
              onChange={updateHandler}
              name='description'
              sx={{ color: 'text.secondary' }}
              value={formik.values.description || ''} />
          </FormControl>

          <FormControl disabled sx={{ mb: 2 }}>
            <TextField
              label='Configuration details'
              onChange={updateHandler}
              name='productConfiguration'
              sx={{ color: 'text.secondary' }}
              value={formik.values.productConfiguration || ''} />
          </FormControl>

          <FormControl disabled sx={{ mb: 2 }}>
            <TextField
              label='Sku code'
              onChange={updateHandler}
              name='skuCode'
              sx={{ color: 'text.secondary' }}
              value={formik.values.skuCode || ''} />
          </FormControl>

          <FormControl sx={{ mb: 2 }}>
            <InputLabel >Product emissions
            </InputLabel>
            <OutlinedInput
              onChange={formik.handleChange}
              label='Product emissions'
              name='kgCarbonEmission'
              sx={{ color: 'text.secondary' }}
              value={formik.values.kgCarbonEmission || ''}
              type='number'
              inputProps={{ min: 0, step: 0.01 }}
              endAdornment={<InputAdornment position="end"><Typography variant='body2' sx={{ color: 'text.secondary' }}>kg CO<sub>2</sub>e</Typography></InputAdornment>}
            />
          </FormControl>

          <Stack sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', mt: 2 }}>
            <Box sx={{ mr: 2 }}>
              <Button variant='text' component={Link} to={!isEditPage ? '/products' : `/products/${finishedProduct?.id}`}>
                <Typography sx={{ color: 'primary.main' }}>Cancel </Typography></Button>
            </Box>
            <Button onClick={() => formik.submitForm()}><Typography>Save</Typography></Button>
          </Stack>

        </Stack>
      </Box >
    )
  }